<template>
  <div>
    <hia-loading v-if="initLoading"></hia-loading>
    <template v-else>
      <div v-loading="loading" element-loading-spinner="nucleus-loader" id="codingDashboard">
        <el-row :gutter="15" type="flex">
          <el-col :span="topSmallStatSpan" style="display: flex;">
            <el-card class="dataCard coding smallCardPadding" shadow="hover">
              <el-row type="flex" align="middle">
                <el-col :span="18">
                  <span class="dataTitle">{{ dashboardData.length ? dashboardData[0].smallStats[0].title : '' }}</span>
                  <span class="dataText">{{ dashboardData.length ? dashboardData[0].smallStats[0].data : '' }}</span>
                  <span class="dataFooter">{{ dashboardData.length ? dashboardData[0].smallStats[0].footer : 'No Data Available' }}</span>
                </el-col>
                <el-col :span="6" style="height: 35px;">
                  <!-- <img width="50%" alt="Coding" src="/static/images/HIA_RGB_codingsupport_badge.png"> -->
                  <div style="width: 35px; height: 35px; margin: 0 auto; border-radius: 100%; background: rgba(255, 196, 12, .8) ">
                    <i style="float:left; font-weight: 200; margin: -7px 0px 0px -4px; font-size: 42px; color: #ffffff;" class="mdi mdi-resistor"></i>
                  </div>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
          <el-col v-if="showCodingChargesCard" :span="topSmallStatSpan" style="display: flex;">
            <el-card class="dataCard coding smallCardPadding" shadow="hover">
              <el-row type="flex" align="middle">
                <el-col :span="18">
                  <span class="dataTitle">{{ dashboardData.length ? dashboardData[0].smallStats[1].title : '' }}</span>
                  <span class="dataText">{{ dashboardData.length ? dashboardData[0].smallStats[1].data : '' }}</span>
                  <span class="dataFooter">{{ dashboardData.length ? dashboardData[0].smallStats[1].footer : '' }}</span>
                </el-col>
                <el-col :span="6" style="height: 35px;">
                  <!-- <img width="50%" alt="Coding" src="/static/images/HIA_RGB_codingsupport_badge.png"> -->
                  <div style="width: 35px; height: 35px; margin: 0 auto; border-radius: 100%; background: rgba(255, 196, 12, .8) ">
                    <i style="float:left; font-weight: 200; margin: -7px 0px 0px -4px; font-size: 42px; color: #ffffff;" class="mdi mdi-resistor"></i>
                  </div>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
          <el-col :span="topSmallStatSpan" style="display: flex;">
            <el-card class="dataCard coding smallCardPadding" shadow="hover">
              <el-row type="flex" align="middle">
                <el-col :span="18">
                  <span class="dataTitle">{{ dashboardData.length ? dashboardData[0].smallStats[2].title : '' }}</span>
                  <span class="dataText">{{ dashboardData.length ? dashboardData[0].smallStats[2].data : '' }}</span>
                  <span class="dataFooter">{{ dashboardData.length ? dashboardData[0].smallStats[2].footer : '' }}</span>
                </el-col>
                <el-col :span="6" style="height: 35px;">
                  <!-- <img width="50%" alt="Coding" src="/static/images/HIA_RGB_codingsupport_badge.png"> -->
                  <div style="width: 35px; height: 35px; margin: 0 auto; border-radius: 100%; background: rgba(255, 196, 12, .8) ">
                    <i style="float:left; font-weight: 200; margin: -7px 0px 0px -4px; font-size: 42px; color: #ffffff;" class="mdi mdi-resistor"></i>
                  </div>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
          <el-col v-if="showCodingQuerySmallStat" :span="topSmallStatSpan" style="display: flex;">
            <el-card class="dataCard coding smallCardPadding" shadow="hover">
              <el-row type="flex" align="middle">
                <el-col :span="18">
                  <span class="dataTitle">{{ dashboardData.length ? dashboardData[0].smallStats[3].title : '' }}</span>
                  <span class="dataText">{{ dashboardData.length ? dashboardData[0].smallStats[3].data : '' }}</span>
                  <span class="dataFooter">{{ dashboardData.length ? dashboardData[0].smallStats[3].footer : '' }}</span>
                </el-col>
                <el-col :span="6" style="height: 35px;">
                  <!-- <img width="50%" alt="Coding" src="/static/images/HIA_RGB_codingsupport_badge.png"> -->
                  <div style="width: 35px; height: 35px; margin: 0 auto; border-radius: 100%; background: rgba(255, 196, 12, .8) ">
                    <i style="float:left; font-weight: 200; margin: -7px 0px 0px -4px; font-size: 42px; color: #ffffff;" class="mdi mdi-resistor"></i>
                  </div>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row>
        <el-row type="flex" class="dataTables" style="margin-top: 15px; text-align:left; height: 350px;" :gutter="15">
          <el-col :span="firstRowPrimarySpan">
            <el-card class="dataCard codingCard" shadow="always">
              <div slot="header">
                <el-tooltip popper-class="nucleusTooltip" :content="`Patient Type analysis for records coded between ${codingDateRange[0]} and ${codingDateRange[1]}.`" placement="bottom" effect="light">
                  <span style="text-decoration: underline;">{{ dashboardData.length ? dashboardData[0].largeStats[1].title : '' }}</span>
                </el-tooltip>
                <span class="expandCollapseButton" title="Expand Patient Types section" @click="toggleCardModal('PatientTypesTable', 'Patient Types')"><i class="mdi mdi-arrow-expand"></i></span>
              </div>
              <PatientTypesTable :dashboardData="dashboardData"></PatientTypesTable>
            </el-card>
          </el-col>
          <el-col v-if="hasCodingInpatient" :span="8">
            <el-card class="dataCard codingCard" shadow="always">
              <div slot="header">
                <el-tooltip popper-class="nucleusTooltip" :content="`Top DRGs coded between ${codingDateRange[0]} and ${codingDateRange[1]}.`" placement="bottom" effect="light">
                  <span style="text-decoration: underline;">{{ dashboardData.length ? dashboardData[0].largeStats[2].title : '' }}</span>
                </el-tooltip>
                <span class="expandCollapseButton" title="Expand Top DRGs section" @click="toggleCardModal('TopDrgsTable', 'Top DRGs')"><i class="mdi mdi-arrow-expand"></i></span>
              </div>
              <TopDrgsTable :dashboardData="dashboardData"></TopDrgsTable>
            </el-card>
          </el-col>
          <el-col v-if="showCodingQueryCard" :span="firstRowSecondarySpan">
            <el-card class="dataCard codingCard" shadow="always">
              <div slot="header">
                <el-tooltip popper-class="nucleusTooltip" :content="`Query analysis for records coded between ${codingDateRange[0]} and ${codingDateRange[1]}.`" placement="bottom" effect="light">
                  <span style="text-decoration: underline;">{{ dashboardData.length ? dashboardData[0].largeStats[3].title : '' }}</span>
                </el-tooltip>
                <span class="expandCollapseButton" title="Expand Query List section" @click="toggleCardModal('QueryListTable', 'Query List')"><i class="mdi mdi-arrow-expand"></i></span>
              </div>
              <QueryListTable :dashboardData="dashboardData" key="queryListTable" @detailsClick="buildDetailsPopoverFromComponent"> </QueryListTable>
            </el-card>
          </el-col>
          <el-col v-if="showConsultantsInFirstRow" :span="12">
            <el-card class="dataCard codingCard" shadow="always">
              <div slot="header">
                <el-tooltip popper-class="nucleusTooltip" :content="`Consultants who coded records between ${codingDateRange[0]} and ${codingDateRange[1]}.`" placement="bottom" effect="light">
                  <span style="text-decoration: underline;">{{ dashboardData.length ? dashboardData[0].largeStats[0].title : '' }}</span>
                </el-tooltip>
                <span class="expandCollapseButton" title="Expand Query List section" @click="toggleCardModal('ConsultantsTable', 'Consultants')"><i class="mdi mdi-arrow-expand"></i></span>
              </div>
              <ConsultantsTable :dashboardData="dashboardData" :tableHeight="300"></ConsultantsTable>
            </el-card>
          </el-col>
        </el-row>
        <el-row v-if="hasCodingInpatient" type="flex" class="dataTables" style="margin-top: 15px; text-align:left; height: 350px;" :gutter="15">
          <el-col :span="12">
            <el-card class="dataCard codingCard" shadow="always">
              <div slot="header">
                <el-tooltip popper-class="nucleusTooltip" :content="`Potential Patient Safety Indicator (PSI) triggers for records coded between ${codingDateRange[0]} and ${codingDateRange[1]}.`" placement="bottom" effect="light">
                  <span style="text-decoration: underline;">{{ dashboardData.length ? dashboardData[0].largeStats[8].title : '' }}</span>
                </el-tooltip>
                <span class="expandCollapseButton" title="Expand Query List section" @click="toggleCardModal('PatientSafetyIndicatorsTable', 'Patient Safety Indicators')"><i class="mdi mdi-arrow-expand"></i></span>
              </div>
              <PatientSafetyIndicatorsTable :dashboardData="dashboardData" @detailsClick="buildDetailsPopoverFromComponent"> </PatientSafetyIndicatorsTable>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card class="dataCard codingCard" shadow="always">
              <div slot="header">
                <el-tooltip popper-class="nucleusTooltip" :content="`Potential Quality Measure triggers for records coded between ${codingDateRange[0]} and ${codingDateRange[1]}.`" placement="bottom" effect="light">
                  <span style="text-decoration: underline;">{{ dashboardData.length ? dashboardData[0].largeStats[9].title : '' }}</span>
                </el-tooltip>
                <span class="expandCollapseButton" title="Expand Query List section" @click="toggleCardModal('QualityMeasuresTable', 'Quality Measures')"><i class="mdi mdi-arrow-expand"></i></span>
              </div>
              <QualityMeasuresTable :dashboardData="dashboardData" @detailsClick="buildDetailsPopoverFromComponent"> </QualityMeasuresTable>
            </el-card>
          </el-col>
        </el-row>
        <el-row type="flex" class="dataTables" style="margin-top: 15px; text-align:left; height: 500px;" :gutter="15">
          <el-col v-if="showConsultantsInBottomRow" :span="12">
            <el-card class="dataCard codingCard" shadow="always">
              <div slot="header">
                <el-tooltip popper-class="nucleusTooltip" :content="`Consultants who coded records between ${codingDateRange[0]} and ${codingDateRange[1]}.`" placement="bottom" effect="light">
                  <span style="text-decoration: underline;">{{ dashboardData.length ? dashboardData[0].largeStats[0].title : '' }}</span>
                </el-tooltip>
                <span class="expandCollapseButton" title="Expand Query List section" @click="toggleCardModal('ConsultantsTable', 'Consultants')"><i class="mdi mdi-arrow-expand"></i></span>
              </div>
              <ConsultantsTable :dashboardData="dashboardData"></ConsultantsTable>
            </el-card>
          </el-col>
          <el-col :span="pendingReasonsSpan">
            <el-card class="dataCard codingCard" shadow="always">
              <div slot="header">
                <el-tooltip popper-class="nucleusTooltip" :content="`Includes pending records that were coded between ${codingDateRange[0]} and ${codingDateRange[1]}. The Live setting shows records that are currently pending. The Historical setting includes both currently pending records and records that are no longer pending.`" placement="bottom" effect="light">
                  <span style="text-decoration: underline;">{{ dashboardData.length ? dashboardData[0].largeStats[10].title : '' }}</span>
                </el-tooltip>
                <span class="expandCollapseButton" title="Expand Query List section" @click="toggleCardModal('PendingReasonsTable', 'Pending Reasons')"><i class="mdi mdi-arrow-expand"></i></span>
              </div>
              <PendingReasonsTable :dashboardData="dashboardData" @detailsClick="buildDetailsPopoverFromComponent"> </PendingReasonsTable>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </template>

    <div id="schedule">
      <el-dialog title="Coding Schedule" :visible.sync="showCodingSchedule" width="50%">
        <CodingSchedule :dateRange="dateRange" :isOpen="showCodingSchedule"></CodingSchedule>
      </el-dialog>
    </div>

    <div id="codingLogs">
      <el-dialog title="Coding Logs" :visible.sync="showCodingLogs" width="50%">
        <CodingLogs :dateRange="dateRange" :isOpen="showCodingLogs"></CodingLogs>
      </el-dialog>
    </div>

    <div id="codingCalendar">
      <el-dialog title="Coding Calendar" :visible.sync="showCodingCalendar" width="75%" :close-on-click-modal="false">
        <CodingCalendarSchedule :dateRange="dateRange" :isOpen="showCodingCalendar"></CodingCalendarSchedule>
      </el-dialog>
    </div>

    <el-popover ref="dashboardDetailsPopOver" placement="top" width="1100" trigger="click" @after-enter="handleHidePopOver">
      <DetailsPopOver :header="header" :popOverData="popOverData" tableType="accountNumbers" :isCoding="true" :row="row" :isOpen="isOpen"> </DetailsPopOver>
    </el-popover>

    <el-dialog
      :title="modalTitle"
      :visible.sync="showCardModal"
      :before-close="
        () => {
          showCardModal = false
        }
      "
    >
      <!--dynamically show correct modal component -->
      <component :is="modalComponent" :dashboardData="dashboardData" @detailsClick="buildDetailsPopoverFromComponent"> </component>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showCardModal = false">Close</el-button>
      </span>
    </el-dialog>

    <el-dialog width="75%" :title="modalTitle" :visible.sync="showDetailsModal" destroy-on-close>
      <DetailsPopOver v-if="showDetailsModal" :isCoding="true" :header="compDetailText" :isModal="true" :tableType="'accountNumbers'" :reviewType="modalReviewType" :row="row"></DetailsPopOver>
    </el-dialog>
  </div>
</template>

<script>
import { format } from 'date-fns'
import HiaAuthorization from '@/mixins/hiaAuthorization'
import money from '@/mixins/money'
import { mapState, mapActions, mapMutations } from 'vuex'
import CodingSchedule from '@/views/Dashboards/CodingSchedule'
import CodingCalendarSchedule from '@/views/Dashboards/CodingCalendarSchedule'
import CodingLogs from '@/views/Dashboards/CodingLogs'
import DetailsPopOver from '@/views/Dashboards/DetailsPopOver'
import PatientTypesTable from './CodingComponents/PatientTypesTable'
import TopDrgsTable from './CodingComponents/TopDrgsTable'
import QueryListTable from './CodingComponents/QueryListTable'
import PatientSafetyIndicatorsTable from './CodingComponents/PatientSafetyIndicatorsTable'
import QualityMeasuresTable from './CodingComponents/QualityMeasuresTable'
import ConsultantsTable from './CodingComponents/ConsultantsTable'
import PendingReasonsTable from './CodingComponents/PendingReasonsTable'

export default {
  data: function() {
    return {
      isOpen: false,
      header: '',
      popOverData: [],
      tableType: '',
      row: {},
      modalTitle: '',
      modalComponent: '',
      showCardModal: false,
      popperClickTarget: undefined,
      expandQueries: false,
      expandStatistics: false,
      expandCoders: false,
      showAll: true,
      dateRange: [],
      loading: false,
      initLoading: false,
      showCodingSchedule: false,
      showCodingLogs: false,
      showCodingCalendar: false,
      showDetailsModal: false,
      modalReviewType: 'final'
    }
  },
  name: 'CodingDashboard',
  mixins: [HiaAuthorization, money],
  props: {},
  components: {
    CodingSchedule,
    CodingLogs,
    CodingCalendarSchedule,
    DetailsPopOver,
    PatientTypesTable,
    TopDrgsTable,
    QueryListTable,
    PatientSafetyIndicatorsTable,
    QualityMeasuresTable,
    ConsultantsTable,
    PendingReasonsTable
  },
  methods: {
    ...mapActions('reports/', ['GET_REPORTS', 'GENERATE_REPORT']),
    ...mapActions('dashboard/', ['GET_DASHBOARD', 'GET_DASHBOARD_PROJECTS', 'POST_REVIEW_DASHBOARD_ALL', 'GET_CODINGSUMMARY_PDF_URL']),
    ...mapMutations('dashboard/', ['SET_CODING_DATE_RANGE']),
    initialize() {},
    moneyFormatter(row, column) {
      return `$${this.formatMoney(row.totalCharges || row.consultantTotalCharges)}`
    },
    actionMenuCommands(object) {
      if (object.action === 'viewSchedule') {
        this.showCodingSchedule = true
      } else if (object.action === 'viewCodingLogs') {
        this.showCodingLogs = true
      } else if (object.action === 'viewCodingSummary') {
        let payload = {
          startDate: this.dateRange[0],
          endDate: this.dateRange[1]
        }
        const loading = this.$loading({
          lock: true,
          text: 'Getting ready...',
          spinner: 'nucleus-loader',
          background: 'rgba(255, 255, 255, 0.7)'
        })
        this.GET_CODINGSUMMARY_PDF_URL(payload).then(response => {
          loading.close()
          window.open(`/static/pdfjs/web/viewer.html?file=${response}`, '_blank')
        })
      } else if (object.action === 'viewCalendar') {
        this.showCodingCalendar = true
      } else if (object.action === 'viewCodingLogDetails') {
        let payload = {
          startDate: this.dateRange[0],
          endDate: this.dateRange[1],
          body: { id: 8, reportName: 'Coding Log Details', reportPath: 'Client_CodingDetails', reportDescription: 'Provides Hours Worked, and a listing of all accounts coded/finalized for each day in the date range.', clientNumberParameterName: 'ClientNumber', reportType: 1 }
        }
        const loading = this.$loading({
          lock: true,
          text: 'Getting ready...',
          spinner: 'nucleus-loader',
          background: 'rgba(255, 255, 255, 0.7)'
        })
        this.GENERATE_REPORT(payload).then(
          response => {
            loading.close()
            let fileName = this.getFileNameFromResponse(response)
            this.generateDownloadLink(response.data, fileName)
          },
          error => {
            this.$message.error('Error generating report')
            console.log(error)
          }
        )
      } else if (object.action === 'viewFinal') {
        // view final
        let payload = {
          startDate: this.dateRange[0],
          endDate: this.dateRange[1],
          e: document.getElementById('codingdd')
        }
        this.buildDetailsFinalized(payload)
      }
    },
    openPDFViewer(newWindow, worksheet) {
      var byteCharacters = atob(worksheet)
      var byteNumbers = new Array(byteCharacters.length)
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      var byteArray = new Uint8Array(byteNumbers)
      var blob = new Blob([byteArray], {
        type: 'application/pdf'
      })
      var url = window.URL.createObjectURL(blob)
      var viewerUrl = '/static/pdfjs/web/viewer.html?file=' + encodeURI(url)
      newWindow.location.href = viewerUrl
    },
    toggleCardModal(modalComponent, modalTitle) {
      this.modalComponent = modalComponent
      this.modalTitle = modalTitle
      this.showCardModal = true
    },
    toggleExpandCard(card) {
      switch (card) {
        case 'queries':
          this.expandQueries = !this.expandQueries
          break
        case 'statistics':
          this.expandStatistics = !this.expandStatistics
          break
        case 'coders':
          this.expandCoders = !this.expandCoders
          break
      }
      this.showAll = !this.showAll
    },
    showDetailsPopover(e) {
      let popper = this.$refs.dashboardDetailsPopOver
      popper.doDestroy()
      popper.doClose()

      this.$nextTick(() => {
        this.popperClickTarget = e.target
        popper.doDestroy()
        popper.referenceElm = this.popperClickTarget
        this.isOpen = true
        popper.doShow()
      })
    },
    handleHidePopOver() {
      let popper = this.$refs.dashboardDetailsPopOver
      let handler = e => {
        if (e.target !== popper.$el && e.target !== this.popperClickTarget) {
          popper.doClose()
          popper.doDestroy()
        }
        document.removeEventListener('click', handler, false)
      }
      document.addEventListener('click', handler, false)
    },
    buildDetailsPopover(title, accounts, e) {
      this.clearPopOverData()
      this.$nextTick(() => {
        this.tableType = 'accountNumbers'
        this.header = title
        this.popOverData = []
        this.row.accountNumbers = accounts
        this.reviewType = 'coding'
        this.showDetailsPopover(e)
      })
    },
    buildDetailsPopoverFromComponent(payload) {
      this.clearPopOverData()
      this.$nextTick(() => {
        this.tableType = 'accountNumbers'
        this.header = payload.title
        this.popOverData = []
        this.row.accountNumbers = payload.accounts
        this.reviewType = 'coding'
        this.showDetailsPopover(payload.e)
      })
    },
    buildDetailsFinalized(payload) {
      // this.clearPopOverData()
      // this.$nextTick(() => {
      //   this.tableType = 'accountNumbers'
      //   this.header = 'Finalized Records'
      //   this.popOverData = []
      //   // this.row.accountNumbers = payload.accounts
      //   this.reviewType = 'final'
      //   this.showDetailsPopover(payload.e)
      // })
      this.showDetailsModal = true
    },
    clearPopOverData() {
      this.tableType = ''
      this.header = ''
      this.popOverData = []
      this.row = {}
      this.isOpen = false
    },
    generateDownloadLink(file, fileName) {
      let blob = new Blob([file], { type: 'application/octet-stream' })
      const link = document.createElement('a')
      link.setAttribute('style', 'display: hidden;')
      // link.setAttribute('download', 'download')
      link.id = 'hiddenLink'
      link.href = window.URL.createObjectURL(blob)
      link.download = fileName
      document.getElementsByTagName('body')[0].appendChild(link)
      document.getElementById('hiddenLink').click()
      // remove link
      const timerId = setInterval(() => {
        document.getElementById('hiddenLink').remove()
        clearInterval(timerId)
      }, 500)
    },
    getFileNameFromResponse(response) {
      var contdisp = response.headers['content-disposition']
      var parts = contdisp.split('; ')

      for (var i = 0; i < parts.length; i++) {
        if (parts[i].indexOf('filename=') > -1) {
          let filename = parts[1].replace('filename=', '')
          filename = filename.replace(/"/g, '')
          return filename
        }
      }
    },
    formatDate(date) {
      return format(date, 'MM/dd/yyyy')
    }
  },
  created: function() {
    this.initialize()
  },
  computed: {
    ...mapState('user/', ['currentClient', 'currentClientId']),
    ...mapState('dashboard/', ['dashboardData', 'codingDateRange', 'currentlyPending']),
    hasCodingInpatient() {
      return !!(this.dashboardData.length && this.dashboardData[0] && this.dashboardData[0].hasInpatient)
    },
    hasCodingOutpatient() {
      return !!(this.dashboardData.length && this.dashboardData[0] && this.dashboardData[0].hasOutpatient)
    },
    isCodingProOnly() {
      return !this.hasCodingInpatient && !this.hasCodingOutpatient
    },
    showCodingChargesCard() {
      return !this.isCodingProOnly
    },
    showCodingQuerySmallStat() {
      return !this.isCodingProOnly
    },
    topSmallStatSpan() {
      return this.isCodingProOnly ? 12 : 6
    },
    showCodingQueryCard() {
      return this.hasCodingInpatient || this.hasCodingOutpatient
    },
    showConsultantsInFirstRow() {
      return this.isCodingProOnly
    },
    showConsultantsInBottomRow() {
      return !this.isCodingProOnly
    },
    firstRowPrimarySpan() {
      if (this.hasCodingInpatient) return 8
      if (this.hasCodingOutpatient) return 12
      return 12
    },
    firstRowSecondarySpan() {
      return this.hasCodingInpatient ? 8 : 12
    },
    pendingReasonsSpan() {
      return this.isCodingProOnly ? 24 : 12
    },
    compMinDate() {
      return new Date(this.dateRange[0])
    },
    compMaxDate() {
      return new Date(this.dateRange[1])
    },
    compDetailText() {
      return `Finalized Accounts from ${this.dateRange[0]} to ${this.dateRange[1]}`
    }
  }
}
</script>

<style scoped>
.dataTables .caret-wrapper {
  display: none !important;
}

.dataTables thead th .cell:hover {
  color: #005695;
  text-decoration: underline;
}

.dataTables .el-tooltip {
  width: 90% !important;
}

>>> .el-table__expanded-cell {
  padding-left: 1% !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  padding-right: 0px !important;
}

>>> #queryDrillDownTable thead {
  display: none;
}

>>> #pendingDrillDownTable thead {
  display: none;
}

.dataTables >>> .el-table__body,
>>> .el-table__header {
  width: 100% !important;
  table-layout: inherit !important;
}

>>> .parentLargeCell {
  width: 16%;
}

>>> .childLargeCell {
  width: 27%;
}

>>> .smallCell {
  width: 12%;
}

>>> .parentLargeCell .cell,
>>> .childLargeCell .cell,
>>> .smallCell .cell {
  max-width: 100% !important;
}

#codingLargeStat2 >>> .el-table__expand-icon {
  float: left;
}

>>> .dottedUnderline {
  cursor: pointer;
  text-decoration: underline;
  text-decoration-style: dotted;
}
</style>
